import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import CONSTANTS from 'src/app/app.config';
import { AuthService } from 'src/app/modules/auth/auth.service';

import { Broadcaster } from './../../../utils/broadcaster.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input() drawer;

  isLoggedIn$: Observable<boolean>;
  loggedUser: string = '';
  logoPath: string = CONSTANTS.LOGO_PATH;
  headerColor: string = CONSTANTS.COLORS.HEADER;
  appVersion: string = CONSTANTS.APP_VERSION;

  constructor(
    private authService: AuthService,
    private broadcaster: Broadcaster
  ) { }

  click() {
    this.broadcaster.broadcast('openMenu');
    // this.drawer.toggle();
  }

  navigate(link){
    window.open(link, '_blank');

  }

  logout(){
    this.authService.logout();
  }

  ngOnInit() {
    this.broadcaster.on('logout').subscribe(()=>{
      this.loggedUser = '';
    });

    this.broadcaster.on('login').subscribe(()=>{
      let currentUser = JSON.parse(localStorage.getItem("currentUser"));
      if (currentUser) {
        this.loggedUser = currentUser.userData.email;
      }
    })

    this.isLoggedIn$ = this.authService.isLoggedIn;
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (currentUser) {
      this.loggedUser = currentUser.userData.email;
    }
  }

}
